// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgressBar_container__BFnQu","progress":"ProgressBar_progress__20v60"};